var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFbC(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.89895 0.62207C3.07724 0.62207 0 3.73928 0 7.61063V31.9073C0 35.7787 3.07724 38.8959 6.89895 38.8959H19.8987V23.9332H15.9929V18.5462H19.8987V13.9437C19.8987 10.3278 22.2064 7.00782 27.5226 7.00782C29.675 7.00782 31.2667 7.21713 31.2667 7.21713L31.1415 12.2478C31.1415 12.2478 29.5182 12.2322 27.7469 12.2322C25.8298 12.2322 25.5224 13.127 25.5224 14.6124V18.5462H31.2938L31.0423 23.9332H25.5224V38.8959H30.8841C34.7058 38.8959 37.783 35.7787 37.783 31.9073V7.61067C37.783 3.73931 34.7058 0.622109 30.8841 0.622109L6.89895 0.62207Z",
    fill: "#0879FC"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFbC);
export default __webpack_public_path__ + "static/media/icon-fb-c.4e6cc27060c8a0fa4d33d2e0ebc27984.svg";
export { ForwardRef as ReactComponent };